// Higher order component
import React from 'react';
import { NavigationDots, SocialMedia } from '../component';

const Appwrap = (Component, idName, classNames) => function HOC() {
  return (
    <div id={idName} className={`app__container ${classNames}`}>   {/* template string */}
      <SocialMedia />
      <div className="app__wrapper app__flex">  {/*id to scroll*/}
        <Component />

        <div className="copyright">
          <p className="p-text">@2022 KAMAL</p>
          <p className="p-text">All rights reserved</p>
        </div>
      </div>
      <NavigationDots active={idName} />
    </div>
  );
};

export default Appwrap;
